import FaoClickModal from './FaoClickModal'
import FaoMapHover from './FaoMapHover'
import FaoTiles from './FaoTiles'

export const FaoMapConfig = {
  Click: FaoClickModal,
  Hover: FaoMapHover,
  Controller: FaoTiles,
}
